import { init } from '../init'
import type { State } from '../typings'
import type { ScheduleMode, SchedulingScreen } from '../../../../typings'

export type OpenAction = {
  type: 'open'
  payload: {
    mode: ScheduleMode
    screen: SchedulingScreen
  }
}

export const openAction = (
  state: State,
  payload: OpenAction['payload'],
): State => ({
  ...init(state),
  mode: payload.mode,
  stack: [payload.screen],
})

export const openActionCreator = (
  mode: ScheduleMode,
  screen: SchedulingScreen,
): OpenAction => ({
  type: 'open',
  payload: { mode, screen },
})
